function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { lruMemoize, createSelectorCreator } from 'reselect';
import { warnOnce } from '@mui/x-internals/warning';
import { argsEqual } from "../hooks/utils/useGridSelector.js";
var reselectCreateSelector = createSelectorCreator({
    memoize: lruMemoize,
    memoizeOptions: {
        maxSize: 1,
        equalityCheck: Object.is
    }
});
// TODO v8: Remove this type
// TODO v8: Rename this type to `OutputSelector`
// TODO v8: Remove this type
// TODO v8: Rename this type to `SelectorArgs`
// TODO v8: Remove this type
// TODO v8: Rename this type to `CreateSelectorFunction`
var cache = new WeakMap();
function checkIsAPIRef(value) {
    return 'current' in value && 'instanceId' in value.current;
}
var DEFAULT_INSTANCE_ID = {
    id: 'default'
};
// TODO v8: Remove this function
export var createSelector = function(a, b, c, d, e, f) {
    for(var _len = arguments.length, other = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++){
        other[_key - 6] = arguments[_key];
    }
    if (other.length > 0) {
        throw new Error('Unsupported number of selectors');
    }
    var selector;
    // eslint-disable-next-line id-denylist
    if (a && b && c && d && e && f) {
        selector = function(stateOrApiRef, instanceIdParam) {
            var isAPIRef = checkIsAPIRef(stateOrApiRef);
            var instanceId = instanceIdParam !== null && instanceIdParam !== void 0 ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : DEFAULT_INSTANCE_ID;
            var state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
            var va = a(state, instanceId);
            var vb = b(state, instanceId);
            var vc = c(state, instanceId);
            var vd = d(state, instanceId);
            var ve = e(state, instanceId);
            return f(va, vb, vc, vd, ve);
        };
    // eslint-disable-next-line id-denylist
    } else if (a && b && c && d && e) {
        selector = function(stateOrApiRef, instanceIdParam) {
            var isAPIRef = checkIsAPIRef(stateOrApiRef);
            var instanceId = instanceIdParam !== null && instanceIdParam !== void 0 ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : DEFAULT_INSTANCE_ID;
            var state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
            var va = a(state, instanceId);
            var vb = b(state, instanceId);
            var vc = c(state, instanceId);
            var vd = d(state, instanceId);
            return e(va, vb, vc, vd);
        };
    } else if (a && b && c && d) {
        selector = function(stateOrApiRef, instanceIdParam) {
            var isAPIRef = checkIsAPIRef(stateOrApiRef);
            var instanceId = instanceIdParam !== null && instanceIdParam !== void 0 ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : DEFAULT_INSTANCE_ID;
            var state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
            var va = a(state, instanceId);
            var vb = b(state, instanceId);
            var vc = c(state, instanceId);
            return d(va, vb, vc);
        };
    } else if (a && b && c) {
        selector = function(stateOrApiRef, instanceIdParam) {
            var isAPIRef = checkIsAPIRef(stateOrApiRef);
            var instanceId = instanceIdParam !== null && instanceIdParam !== void 0 ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : DEFAULT_INSTANCE_ID;
            var state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
            var va = a(state, instanceId);
            var vb = b(state, instanceId);
            return c(va, vb);
        };
    } else if (a && b) {
        selector = function(stateOrApiRef, instanceIdParam) {
            var isAPIRef = checkIsAPIRef(stateOrApiRef);
            var instanceId = instanceIdParam !== null && instanceIdParam !== void 0 ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : DEFAULT_INSTANCE_ID;
            var state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
            var va = a(state, instanceId);
            return b(va);
        };
    } else {
        throw new Error('Missing arguments');
    }
    // We use this property to detect if the selector was created with createSelector
    // or it's only a simple function the receives the state and returns part of it.
    selector.acceptsApiRef = true;
    return selector;
};
// TODO v8: Rename this function to `createSelector`
export var createSelectorV8 = function(a, b, c, d, e, f) {
    for(var _len = arguments.length, other = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++){
        other[_key - 6] = arguments[_key];
    }
    if (other.length > 0) {
        throw new Error('Unsupported number of selectors');
    }
    var selector;
    // eslint-disable-next-line id-denylist
    if (a && b && c && d && e && f) {
        selector = function(stateOrApiRef, args, instanceIdParam) {
            var isAPIRef = checkIsAPIRef(stateOrApiRef);
            var instanceId = instanceIdParam !== null && instanceIdParam !== void 0 ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : DEFAULT_INSTANCE_ID;
            var state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
            var va = a(state, args, instanceId);
            var vb = b(state, args, instanceId);
            var vc = c(state, args, instanceId);
            var vd = d(state, args, instanceId);
            var ve = e(state, args, instanceId);
            return f(va, vb, vc, vd, ve, args);
        };
    // eslint-disable-next-line id-denylist
    } else if (a && b && c && d && e) {
        selector = function(stateOrApiRef, args, instanceIdParam) {
            var isAPIRef = checkIsAPIRef(stateOrApiRef);
            var instanceId = instanceIdParam !== null && instanceIdParam !== void 0 ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : DEFAULT_INSTANCE_ID;
            var state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
            var va = a(state, args, instanceId);
            var vb = b(state, args, instanceId);
            var vc = c(state, args, instanceId);
            var vd = d(state, args, instanceId);
            return e(va, vb, vc, vd, args);
        };
    } else if (a && b && c && d) {
        selector = function(stateOrApiRef, args, instanceIdParam) {
            var isAPIRef = checkIsAPIRef(stateOrApiRef);
            var instanceId = instanceIdParam !== null && instanceIdParam !== void 0 ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : DEFAULT_INSTANCE_ID;
            var state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
            var va = a(state, args, instanceId);
            var vb = b(state, args, instanceId);
            var vc = c(state, args, instanceId);
            return d(va, vb, vc, args);
        };
    } else if (a && b && c) {
        selector = function(stateOrApiRef, args, instanceIdParam) {
            var isAPIRef = checkIsAPIRef(stateOrApiRef);
            var instanceId = instanceIdParam !== null && instanceIdParam !== void 0 ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : DEFAULT_INSTANCE_ID;
            var state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
            var va = a(state, args, instanceId);
            var vb = b(state, args, instanceId);
            return c(va, vb, args);
        };
    } else if (a && b) {
        selector = function(stateOrApiRef, args, instanceIdParam) {
            var isAPIRef = checkIsAPIRef(stateOrApiRef);
            var instanceId = instanceIdParam !== null && instanceIdParam !== void 0 ? instanceIdParam : isAPIRef ? stateOrApiRef.current.instanceId : DEFAULT_INSTANCE_ID;
            var state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
            var va = a(state, args, instanceId);
            return b(va, args);
        };
    } else {
        throw new Error('Missing arguments');
    }
    // We use this property to detect if the selector was created with createSelector
    // or it's only a simple function the receives the state and returns part of it.
    selector.acceptsApiRef = true;
    return selector;
};
// TODO v8: Remove this function
export var createSelectorMemoized = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var selector = function(stateOrApiRef, instanceId) {
        var isAPIRef = checkIsAPIRef(stateOrApiRef);
        var cacheKey = isAPIRef ? stateOrApiRef.current.instanceId : instanceId !== null && instanceId !== void 0 ? instanceId : DEFAULT_INSTANCE_ID;
        var state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        if (process.env.NODE_ENV !== 'production') {
            if (cacheKey.id === 'default') {
                warnOnce([
                    'MUI X: A selector was called without passing the instance ID, which may impact the performance of the grid.',
                    'To fix, call it with `apiRef`, for example `mySelector(apiRef)`, or pass the instance ID explicitly, for example `mySelector(state, apiRef.current.instanceId)`.'
                ]);
            }
        }
        var cacheArgsInit = cache.get(cacheKey);
        var cacheArgs = cacheArgsInit !== null && cacheArgsInit !== void 0 ? cacheArgsInit : new Map();
        var cacheFn = cacheArgs === null || cacheArgs === void 0 ? void 0 : cacheArgs.get(args);
        if (cacheArgs && cacheFn) {
            // We pass the cache key because the called selector might have as
            // dependency another selector created with this `createSelector`.
            return cacheFn(state, cacheKey);
        }
        var fn = reselectCreateSelector.apply(void 0, _to_consumable_array(args));
        if (!cacheArgsInit) {
            cache.set(cacheKey, cacheArgs);
        }
        cacheArgs.set(args, fn);
        return fn(state, cacheKey);
    };
    // We use this property to detect if the selector was created with createSelector
    // or it's only a simple function the receives the state and returns part of it.
    selector.acceptsApiRef = true;
    return selector;
};
// TODO v8: Rename this function to `createSelectorMemoized`
export var createSelectorMemoizedV8 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var selector = function(stateOrApiRef, selectorArgs, instanceId) {
        var isAPIRef = checkIsAPIRef(stateOrApiRef);
        var cacheKey = isAPIRef ? stateOrApiRef.current.instanceId : instanceId !== null && instanceId !== void 0 ? instanceId : DEFAULT_INSTANCE_ID;
        var state = isAPIRef ? stateOrApiRef.current.state : stateOrApiRef;
        if (process.env.NODE_ENV !== 'production') {
            if (cacheKey.id === 'default') {
                warnOnce([
                    'MUI X: A selector was called without passing the instance ID, which may impact the performance of the grid.',
                    'To fix, call it with `apiRef`, for example `mySelector(apiRef)`, or pass the instance ID explicitly, for example `mySelector(state, apiRef.current.instanceId)`.'
                ]);
            }
        }
        var cacheArgsInit = cache.get(cacheKey);
        var cacheArgs = cacheArgsInit !== null && cacheArgsInit !== void 0 ? cacheArgsInit : new Map();
        var cacheFn = cacheArgs === null || cacheArgs === void 0 ? void 0 : cacheArgs.get(args);
        if (cacheArgs && cacheFn) {
            if (!argsEqual(cacheFn.selectorArgs, selectorArgs)) {
                var reselectArgs = selectorArgs !== undefined ? _to_consumable_array(args.slice(0, args.length - 1)).concat([
                    function() {
                        return selectorArgs;
                    },
                    args[args.length - 1]
                ]) : args;
                var fn = reselectCreateSelector.apply(void 0, _to_consumable_array(reselectArgs));
                fn.selectorArgs = selectorArgs;
                cacheArgs.set(args, fn);
                return fn(state, selectorArgs, cacheKey);
            }
            // We pass the cache key because the called selector might have as
            // dependency another selector created with this `createSelector`.
            return cacheFn(state, selectorArgs, cacheKey);
        }
        var reselectArgs1 = selectorArgs !== undefined ? _to_consumable_array(args.slice(0, args.length - 1)).concat([
            function() {
                return selectorArgs;
            },
            args[args.length - 1]
        ]) : args;
        var fn1 = reselectCreateSelector.apply(void 0, _to_consumable_array(reselectArgs1));
        fn1.selectorArgs = selectorArgs;
        if (!cacheArgsInit) {
            cache.set(cacheKey, cacheArgs);
        }
        cacheArgs.set(args, fn1);
        return fn1(state, selectorArgs, cacheKey);
    };
    // We use this property to detect if the selector was created with createSelector
    // or it's only a simple function the receives the state and returns part of it.
    selector.acceptsApiRef = true;
    return selector;
};
